export interface INotificationsContactInfoInput {
    name: string;
    email: string;
    phone: string;
}
